const questionFields = [
    {
        id: 1,
        field: 'Question',
        field_key: 'question',
        desc: 'Question',
        type: 'text_area',
    },
    {
        id: 2,
        field: 'Certification Name',
        field_key: 'certification_name',
        desc: 'The name of the certification',
        type: 'dropdown',
    },
    {
        id: 3,
        field: 'Certification Version',
        field_key: 'certification_version',
        desc: 'The version of the certification standard',
        type: 'text',
    },
    {
        id: 3.5,
        field: 'Section Name',
        field_key: 'section_name',
        desc: 'The version of the certification standard',
        type: 'dropdown',
    },
    {
        id: 4,
        field: 'Section Number ',
        field_key: 'section_number',
        desc: 'The exact section in the certification document where this requirement is stated.',
        type: 'numeric',
    },
    {
        id: 5,
        field: 'Question ID/Code',
        field_key: 'question_code',
        desc: 'The version of the certification standard',
        type: 'text',
    },
    {
        id: 6,
        field: 'Mandatory/Non-Mandatory',
        field_key: 'mandatory',
        desc: 'The version of the certification standard',
        type: 'dropdown',
    },
    {
        id: 7,
        field: 'Type of requirement',
        field_key: 'requirement_type',
        desc: 'The version of the certification standard',
        type: 'dropdown',
    },
    {
        id: 8,
        field: 'Criticality Level',
        field_key: 'criticality_level',
        desc: 'The version of the certification standard',
        type: 'dropdown',
    },
    {
        id: 9,
        field: 'Consequence of Non-Compliance',
        field_key: 'nc_consequence',
        desc: 'The version of the certification standard',
        type: 'dropdown',
    },
    {
        id: 10,
        field: 'Question Category',
        field_key: 'question_category',
        desc: 'The version of the certification standard',
        type: 'dropdown',
    },
    {
        id: 11,
        field: 'Question Type',
        field_key: 'question_type',
        desc: 'The version of the certification standard',
        type: 'dropdown',
    },
    {
        id: 11.5,
        field: 'Answer options',
        field_key: 'question_options',
        desc: 'The version of the certification standard',
        type: 'text',
    },
    {
        id: 12,
        field: 'Logical Dependency',
        field_key: 'logical_dependency',
        desc: 'The version of the certification standard',
        type: 'text',
    },
    {
        id: 13,
        field: 'Scoring Weightage',
        field_key: 'scoring_weightage',
        desc: 'The version of the certification standard',
        type: 'text',
    },
    {
        id: 14,
        field: 'Evidence Required ',
        field_key: 'evidence_required',
        desc: 'The version of the certification standard',
        type: 'dropdown',
    },
    {
        id: 15,
        field: 'Verification Method',
        field_key: 'verification_method',
        desc: 'The version of the certification standard',
        type: 'dropdown',
    },
    {
        id: 16,
        field: 'Frequency of Check',
        field_key: 'audit_frequency',
        desc: 'The version of the certification standard',
        type: 'dropdown',
    },

    {
        id: 17,
        field: 'Responsible Party',
        field_key: 'responsible_party',
        desc: 'The version of the certification standard',
        type: 'dropdown',
    },
    {
        id: 18,
        field: 'Applicable Regions',
        field_key: 'applicable_regions',
        desc: 'The version of the certification standard',
        type: 'text',
    },
    {
        id: 19,
        field: 'Applicable Farm Size/Type',
        field_key: 'applicable_farm_size',
        desc: 'The version of the certification standard',
        type: 'dropdown',
    },
    {
        id: 20,
        field: 'Regulatory Reference',
        field_key: 'regulatory_reference',
        desc: 'The version of the certification standard',
        type: 'text',
    },
    {
        id: 21,
        field: 'Related Questions',
        field_key: 'related_question',
        desc: 'The version of the certification standard',
        type: 'text',
    },
    {
        id: 22,
        field: 'Implementation Guidance',
        field_key: 'implementation_guidance',
        desc: 'The version of the certification standard',
        type: 'text',
    },
    {
        id: 23,
        field: 'Remarks required',
        field_key: 'remarks',
        desc: 'The version of the certification standard',
        type: 'bool',
    },

]

export default questionFields;